import * as React from "react";
import { RootStore } from './RootStore';

export const StoreContext = React.createContext(new RootStore());
export const SotoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);
